// import React from 'react';
// import myshop from "../../assets/image/ac.jpeg"
// import "../../index.css"

// function Cards() {
//   return (
//     <div id="" className="container-fluid px-md-5 py-3">
//     <div className="d-md-flex align-items-center justify-content-between mb-4">
//       <h3 className="m-0 text-default">Our Partners</h3>
//     </div>

//     <marquee behavior="smooth" direction="">
//      <div className="d-flex gap-4">

//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//       <div className="" style={{ width: "200px", height: "100px" }}>
//         <img
//           src={myshop}
//           alt="myimg"
//           className="img-fluid w-100 h-100 object-fit-cover rounded"
//         />
//       </div>
//      </div>
//     </marquee>
//   </div>
//   )
// }

// export default Cards


import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';

import myshop3 from '../../assets/image/voltaslogo.jpeg';
import myshop4 from '../../assets/image/Daikinlogo.png';
import myshop5 from '../../assets/image/bluestar.png';
import myshop6 from '../../assets/image/hitachilogo.png';

import '../../index.css';

function Cards() {
  // Array of partner images
  const partnerImages = [myshop3, myshop4,myshop5,myshop6];

  return (
    <div id="CardsSlider" className="container-fluid px-md-5 py-3">
      <div className="d-md-flex align-items-center justify-content-between mb-4">
        <h2 className="m-0 text-primary fw-bold">Our Partners</h2>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={2}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        grabCursor={true}
        freeMode={true}
        breakpoints={{
          576: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          992: { slidesPerView: 5 },
          1200: { slidesPerView: 6 },
        }}
        className="mySwiper"
        style={{ animationTimingFunction: "linear" }}
      >
        {[...Array(10)].flatMap(() =>
          partnerImages.map((img, index) => (
            <SwiperSlide key={index + Math.random()}>
              <div style={{ width: '100%', height: '100px' }}>
                <img
                  src={img}
                  alt={`partner-${index}`}
                  className="img-fluid w-100 h-100 object-fit-cover rounded"
                />
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>
    </div>
  );
}

export default Cards;

